import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from './http.service';
import { Dossier } from '../bo/dossier';
import { Fichier, DirectoryType } from '../bo/fichier';
import { FileCategoryEnum } from '../bo/fileCategoryEnum';

@Injectable({
  providedIn: 'root'
})
export class DocumentStorageService {

  constructor(private readonly http: HttpService) { }

  // Workflow Steps
  getWorkflowStepFolder(stepId: number): Observable<Dossier> {
    return this.http.get<Dossier>('WorkflowSteps/' + stepId + '/Folder');
  }

  // Folders
  addFolder(apiEndPoint: string, stepId: number, newFolder: Dossier): Observable<Dossier> {
    return this.http.post<Dossier, Dossier>(apiEndPoint + '/' + stepId + '/Folders/Add', newFolder);
  }

  renameFolder(apiEndPoint: string, stepId: number, folderId: number, newName: string): Observable<Dossier> {
    return this.http.put<string, Dossier>(apiEndPoint + "/" + stepId + "/Folders/" + folderId, newName);
  }

  deleteFolders(apiEndPoint: string, stepId: number, folders: Dossier[]): Observable<any> {
    return this.http.post(apiEndPoint + "/" + stepId + "/Folders/Delete", folders);
  }

  getStepFolder(apiEndPoint: string, stepId: number): Observable<Dossier> {
    return this.http.get(apiEndPoint + "/" + stepId + '/Folder');
  }

  // Files
  renameFile(apiEndPoint: string, stepId: number, fileId: number, blastId: number | undefined, newName: string): Observable<Dossier> {
    const url = blastId != null
      ? `${apiEndPoint}/${stepId}/Files/${fileId}?blastId=${blastId}`
      : `${apiEndPoint}/${stepId}/Files/${fileId}`;
    return this.http.put<string, Dossier>(url, newName);
  }

  deleteFiles(apiEndPoint: string, stepId: number, blastId: number, files: Fichier[]): Observable<any> {
    return this.http.post(`${apiEndPoint}/${stepId}/Files/Delete/${blastId}`, files);
  }

  uploadFiles(apiEndPoint: string, stepId: number, formData: FormData): Observable<any> {
    return this.http.request('POST', apiEndPoint + '/' + stepId + '/Files/Upload', formData);
  }

  // File operations
  checkFilesExist(fileFolder: FileFolder): Observable<Boolean> {
    return this.http.post<FileFolder, Boolean>('Files/ExistFiles?fileType=' + DirectoryType.USERFILES, fileFolder);
  }

  downloadFiles(fileFolder: FileFolder, stepId?: number, blastId?: number , fileCategory?: FileCategoryEnum): Observable<any> {
    let url = 'Files';
    const queryParams: string[] = [];
    if (stepId != null) queryParams.push(`stepId=${stepId}`);
    if (blastId != null) queryParams.push(`blastId=${blastId}`);
    if (fileCategory != null) queryParams.push(`fileCategory=${fileCategory}`);
    url += '?' + queryParams.join('&');

    return this.http.downloadFilePost(url, fileFolder);

  }

  deleteNonExistentFiles(fileFolder: FileFolder): Observable<Dossier> {
    return this.http.post<FileFolder, Dossier>('Files/DeleteNonExistent', fileFolder);
  }

  downloadSingleFile(query: string): Observable<any> {
    return this.http.downloadFile(query);
  }

getUploadUrl(apiEndPoint: string, request: { fileName: string; fileSize: number; siteId: number; category: string; blastId: number }): Observable<string> {
    return this.http.post<{ fileName: string; fileSize: number; siteId: number; category: string; blastId: number }, string>(
        `${apiEndPoint}/request-upload-url`,
        request
    );
}

getDownloadUrl(fileKey: string, id: number, siteId: number, fileType = 0): Observable<{ downloadUrl: string }> {  
  const params = [
    `fileKey=${encodeURIComponent(fileKey)}`,
    `FileId=${id}`,
    `siteId=${siteId}`,
    `fileType=${fileType}`
  ].join('&');
  return this.http.get<{ downloadUrl: string }>(`Files/download-url?${params}`);
}

  openFileInNewWindow(url: string): Observable<any> {
    return this.http.openFile(url).pipe(map(
      (res: any) => {
        return new Blob([res], { type: res.type });
      }));
  }

    public getS3Folder(apiEndPoint:string):string{
      let s3folder = '';
          switch (true) {
          case  apiEndPoint.includes('Sites'):
            s3folder = 'docs';
            break;
          case apiEndPoint.includes('Projects'):
            s3folder = 'projects';
            break;
          default:
            s3folder = 'docs';
        }
        return s3folder;
    }

  getCurrentFileCategory(apiEndPoint: string): FileCategoryEnum {
    if(apiEndPoint === 'Sites'){
      return FileCategoryEnum.Site;
    }
    else if(apiEndPoint === 'Projects'){
      return FileCategoryEnum.Project;
    }
    else{
      return FileCategoryEnum.Workflow;
    }
  }
}

export class FileFolder {
  fichiers: Fichier[];
  dossiers: Dossier[];
  id: number;
  apiEndPoint: string;
}